var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPSinAvancesBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.95 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efb928;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7594",
    className: "cls-1",
    d: "M0,9.16v7.68c0,1.9,1.02,3.66,2.66,4.61l6.65,3.84c1.65.95,3.67.95,5.32,0l6.65-3.84c1.64-.95,2.66-2.71,2.66-4.61v-7.68c0-1.9-1.02-3.66-2.66-4.61L14.63.71c-1.65-.95-3.67-.95-5.32,0l-6.65,3.84C1.02,5.5,0,7.26,0,9.16ZM3.99,6.86l6.65-3.84c.82-.47,1.84-.47,2.66,0l6.65,3.84c.82.48,1.33,1.35,1.33,2.3v7.68c0,.95-.51,1.82-1.33,2.3l-6.66,3.84c-.82.47-1.84.47-2.66,0l-6.65-3.84c-.82-.48-1.33-1.35-1.33-2.3v-7.68c0-.95.51-1.83,1.33-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7595",
    className: "cls-1",
    d: "M6.98,18.05s.04.02.05.03c1.31,1.31,3.09,2.05,4.94,2.05,3.95-.05,7.11-3.29,7.06-7.23-.02-1.83-.75-3.59-2.03-4.9-.01-.02-.02-.04-.03-.05s-.04-.02-.06-.03c-1.31-1.31-3.09-2.05-4.94-2.05-3.95.05-7.11,3.29-7.06,7.23.02,1.83.75,3.59,2.03,4.9.01.02.02.04.03.05ZM11.98,17.28c-.63,0-1.25-.15-1.81-.43l5.63-5.69c1.02,2.12.14,4.67-1.99,5.7-.57.28-1.19.42-1.83.42h0ZM11.98,8.72c.63,0,1.25.15,1.81.43l-5.63,5.69c-1.02-2.12-.14-4.67,1.99-5.7.57-.28,1.19-.42,1.83-.42h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSinAvancesBalken);
export default __webpack_public_path__ + "static/media/p-sin-avances_BALKEN.fccfc5f8e4fab35fbf19915a8b62edb3.svg";
export { ForwardRef as ReactComponent };